module.exports = __webpack_public_path__ + "img/home-saude.84f31ed7.svg";